export const settings = {
	apiUrl: 'https://staging-api.msc2c.org/ferpa'
};